import { render } from "./RoleSwitcher.vue?vue&type=template&id=4424a997&scoped=true"
import script from "./RoleSwitcher.vue?vue&type=script&lang=js"
export * from "./RoleSwitcher.vue?vue&type=script&lang=js"

import "./RoleSwitcher.vue?vue&type=style&index=0&id=4424a997&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4424a997"]])

export default __exports__